<template>
  <div class="typing-row">
    <AgentChatAvatar />
    <ChatBubble direction="incoming">
      <TypingIndicator />
    </ChatBubble>
  </div>
</template>

<script setup lang="ts">
import { ChatBubble, TypingIndicator } from '@tallo/design-system';

import AgentChatAvatar from './agent-chat-avatar.vue';
</script>

<style scoped lang="scss">
.typing-row {
  display: flex;
  gap: 0.5625rem;
}
</style>
